import React from 'react'

const numberSuffixes = {
  "en-IN": { thousand: "K", lakh: "M", crore: "B" },
  "en-GB": { thousand: "K", lakh: "M", crore: "B" },
  "en-US": { thousand: "K", lakh: "M", crore: "B" },
  "hi": { thousand: "हजार", lakh: "लाख", crore: "करोड़" },
  "es": { thousand: "mil", lakh: "M", crore: "mil M" },
  "fr": { thousand: "k", lakh: "M", crore: "Md" },
  "de": { thousand: "Tsd", lakh: "Mio", crore: "Mrd" },
  "ja": { thousand: "千", lakh: "万", crore: "億" },
  "ru": { thousand: "тыс", lakh: "млн", crore: "млрд" },
  "zh": { thousand: "千", lakh: "万", crore: "亿" },
  "ko": { thousand: "의", lakh: "만", crore: "천만" },
  "pt": { thousand: "mil", lakh: "M", crore: "bi" },
  "ar": { thousand: "ألف", lakh: "م", crore: "ب" },
  "it": { thousand: "mila", lakh: "mln", crore: "mld" },
  "nl": { thousand: "K", lakh: "mln", crore: "mld" },
  "fa": { thousand: "هزار", lakh: "میلیون", crore: "میلیارد" },
  "tr": { thousand: "B", lakh: "Mln", crore: "Milyar" },
  "pl": { thousand: "K", lakh: "M", crore: "B" },
  "cs": { thousand: "tis", lakh: "mil", crore: "mld" },
  "da": { thousand: "tus", lakh: "mio", crore: "mia" },
  "hu": { thousand: "K", lakh: "M", crore: "B" },
  "id": { thousand: "rb", lakh: "jt", crore: "M" },
  "uk": { thousand: "тис", lakh: "млн", crore: "млрд" },
  "ur": { thousand: "ہزار", lakh: "لاکھ", crore: "کروڑ" },
  "tl": { thousand: "K", lakh: "M", crore: "B" },
  "ms": { thousand: "K", lakh: "J", crore: "B" },
  "fi": { thousand: "t", lakh: "milj", crore: "mrd." },
  "vi": { thousand: "K", lakh: "tr", crore: "tỷ" },
  "th": { thousand: "พัน", lakh: "หมื่น", crore: "สิบ" },
  "default": { thousand: "K", lakh: "M", crore: "B" }
};



export default numberSuffixes;

